import { recalculateTableWidth } from "../utils/calcTable.js";
import { recalculateIdentification, recalculateStartRelationshipType } from "./modules/relationship/endFlags.js";
import { syncPrimaryKeys, validateForeignKeys } from "./modules/table-column/keys.js";
import { relationshipSort } from "../utils/draw-relationship/sort.js";
//#region src/engine/settle.ts
function settleDocument(state, ctx) {
	syncPrimaryKeys(state);
	validateForeignKeys(state);
	recalculateTableWidth(state, ctx);
	relationshipSort(state, "document", { route: ctx.routes !== false });
	recalculateIdentification(state);
	recalculateStartRelationshipType(state);
}
//#endregion
export { settleDocument };
